export default __webpack_public_path__ + "static/media/fk.30ca3789.jpg";